import { useCallback, useEffect, useState } from 'react'
import { Template, TemplateFilters, TemplateListResult, TemplateOperationMode } from '../../domain/entities/Template'
import { GetTemplatesUseCase } from '../../usecases/GetTemplatesUseCase'
import { AxiosTemplateRepository } from '../../infrastructure/AxiosTemplateRepository'

const repository = new AxiosTemplateRepository()
const getTemplatesUseCase = new GetTemplatesUseCase(repository)

interface UseTemplatesResult {
    templates: Template[]
    loading: boolean
    pagination: { page: number; totalItems: number; totalAllTemplates: number; itemsPerPage: number, totalByClassificationType: TemplateOperationMode[] }
    fetchTemplates: (filters?: TemplateFilters) => Promise<void>
}

export const useTemplates = (initialFilters?: TemplateFilters): UseTemplatesResult => {
    const [templates, setTemplates] = useState<Template[]>([])
    const [loading, setLoading] = useState(false)
    const [pagination, setPagination] = useState({
        page: 1,
        totalItems: 0,
        totalAllTemplates: 0,
        itemsPerPage: 10,
        totalByClassificationType: [] as TemplateOperationMode[],
    })

    const fetchTemplates = useCallback(async (filters?: TemplateFilters) => {
        setLoading(true)
        try {
            const result: TemplateListResult = await getTemplatesUseCase.execute({
                page: 1,
                ...initialFilters,
                ...filters,
            })
            setTemplates(result.items)
            setPagination({
                page: result.page,
                totalItems: result.totalItems,
                totalAllTemplates: result.totalAllTemplates,
                itemsPerPage: result.size,
                totalByClassificationType: result.totalByClassificationType,
            })
        } catch {
            setTemplates([])
        } finally {
            setLoading(false)
        }
    }, [])

    useEffect(() => {
        fetchTemplates(initialFilters)
    }, [])

    return { templates, loading, pagination, fetchTemplates }
}
